import { useEffect, useRef, useState } from "react";
import heroVideo from "@/assets/hero-video.mp4";
import heroImage from "@/assets/hero-interior.webp";
import minzoLogo from "@/assets/minzo-logo.webp";
import { ConversationForm } from "@/components/home/ConversationForm";

export function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const sectionRef = useRef<HTMLElement>(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch(() => {});
    }
  }, []);

  return (
    <section id="concierge" ref={sectionRef} className="relative min-h-screen w-full overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          className={`h-full w-full object-cover transition-opacity duration-1000 ${
            videoLoaded ? "opacity-100" : "opacity-0"
          }`}
          autoPlay
          muted
          loop
          playsInline
          poster={heroImage}
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
        <div
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
            videoLoaded ? "opacity-0" : "opacity-100"
          }`}
          style={{ backgroundImage: `url(${heroImage})` }}
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-foreground/50" />

      {/* Content */}
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 pt-24 pb-16">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img
            src={minzoLogo}
            alt="MINZO"
            fetchPriority="high"
            className="mx-auto h-28 w-auto brightness-0 invert sm:h-40 md:h-52 lg:h-60"
          />
        </div>

        {/* Concierge Form */}
        <div className="w-full max-w-2xl animate-fade-in" style={{ animationDelay: "0.5s" }}>
          <ConversationForm variant="hero" />
        </div>
      </div>
    </section>
  );
}
